module.exports = __webpack_public_path__ + "img/wxqrcode.bb7f6501.jpg";